export default __webpack_public_path__ + "static/media/343.0d48e1ed.gif";